module.exports = __webpack_public_path__ + "static/media/Profile Picture.d793ed4c.png";